// Les clés du stockage local : elles portent le titre du jeu. Les parties créées du temps de
// « Boule de neige » sont reprises automatiquement : chaque ancienne clé est copiée vers la
// nouvelle au premier chargement, et l'ancienne reste en place, en filet de sécurité.
const ANCIEN_PREFIXE = 'boule-de-neige.';
export const STORAGE_PREFIX = 'carnet-de-suzanne.';

/** Reprend les clés de l'ancien titre ; sans effet s'il n'y en a pas (ou sans stockage). */
export function reprendreAnciennesCles(): void {
  try {
    const anciennes: string[] = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const cle = localStorage.key(index);
      if (cle && cle.startsWith(ANCIEN_PREFIXE)) anciennes.push(cle);
    }
    for (const cle of anciennes) {
      const nouvelle = STORAGE_PREFIX + cle.slice(ANCIEN_PREFIXE.length);
      if (localStorage.getItem(nouvelle) === null) {
        const valeur = localStorage.getItem(cle);
        if (valeur !== null) localStorage.setItem(nouvelle, valeur);
      }
    }
  } catch {
    // Stockage indisponible : rien à reprendre.
  }
}
